import type { ResponseError, ZendeskUploadResponse } from '@rtkwlf/rendall';
import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import { useRendallApi } from '../use-rendall-api';

const MAX_ATTACHMENT_SIZE = 20 * 1000 * 1000;

interface UploadZendeskAttachmentMutationFnParams {
  file: File;
}

export const useUploadZendeskAttachment = (
  options?: { maxSize?: number } & Omit<
    UseMutationOptions<
      ZendeskUploadResponse,
      ResponseError,
      UploadZendeskAttachmentMutationFnParams
    >,
    'mutationFn'
  >,
) => {
  const api = useRendallApi();
  const { maxSize = MAX_ATTACHMENT_SIZE, ...mutationOptions } = options ?? {};

  return useMutation({
    mutationFn: ({ file }: UploadZendeskAttachmentMutationFnParams) => {
      const { name, size } = file;
      if (size > maxSize) return Promise.resolve({ token: '' });
      return api.uploadZendeskAttachment({
        body: file,
        filename: name,
      });
    },
    ...mutationOptions,
  });
};
